export { default as capitalizeFirstCharacter } from './capitalizeFirstCharacter'
export { default as generateRandomColor } from './generateRandomColor'
export { default as getCookie } from './getCookie'
export { default as getCurrency } from './getCurrency'
export { default as getInitials } from './getInitials'
export { default as isClient } from './isClient'
export { default as isNumber } from './isNumber'
export { default as loadScript } from './loadScript'
export { default as onClickOutside } from './onClickOutside'
export { default as parseSchemaObject } from './parseSchemaObject'
export { default as setCookie } from './setCookie'
export { default as useDebounce } from './useDebounce'
export { default as useThrottle } from './useThrottle'
export { default as useWindowSize } from './useWindowSize'
export { default as stopDefault } from './stopDefault'
export { default as useIsFirstRender } from './useIsFirstRender'
export { default as useUpdateEffect } from './useUpdateEffect'

export type { Schema } from './parseSchemaObject/parseSchemaObject.types'
export type { Cookies, Req } from './getCookie/getCookie.types'
export type { ScriptProperties } from './loadScript/loadScript.types'
export type { Res, Options } from './setCookie/setCookie.types'
export type { FunctionDebounceType, UseDebounceHookProps } from './useDebounce/useDebounce.types'
export type { FunctionThrottleType, UseThrottleHookProps } from './useThrottle/useThrottle.types'
export type { WindowSize, WindowSizeOptions } from './useWindowSize/useWindowSize.types'
